import React from 'react';
import pt from 'prop-types';
import Loading from './loading';
import api from 'services/api';

const MAX_PROGRESS_PERCENT = 97;
export const CHECK_ASYNC_TIMEOUT = 3000;

export default class LoadingAsyncTask extends React.PureComponent {
  static propTypes = {
    record: pt.object.isRequired,
    tasks: pt.array.isRequired,
    endpoint: pt.string.isRequired,
    size: pt.number,
    onCheckStatus: pt.func,
    onProgressing: pt.func,
    onCompleted: pt.func,
  };

  state = {
    task: null,
    progressing: false,
    progress: 0,
    progressCounter: 0,
  };

  mounted = false;

  componentDidMount() {
    this.mounted = true;
    this.initProgress(true);
  }

  componentWillUnmount() {
    this.mounted = false;
  }

  componentDidUpdate(prevProps) {
    if (prevProps.record?.id !== this.props.record?.id) {
      this.initProgress();
    }
  }

  initProgress(mounting = false) {
    const { record, tasks, onProgressing } = this.props;

    const task = tasks.find(({ type }) => type === record?.async_type);
    const progressing = Boolean(task && record?.async_progressing);
    const progress = record?.async_progress || 0;

    if (progressing) {
      this.setState({
        task,
        progressing,
        progress,
        progressCounter: parseInt(progress),
      });
      this.monitorProgress();
    }

    if (mounting && onProgressing) {
      onProgressing(record, progressing);
    }
  }

  monitorProgress() {
    const { onProgressing, onCompleted } = this.props;

    setTimeout(async () => {
      if (!this.mounted) return;
      const { progressing } = this.state;

      const record = await this.checkStatus();

      if (onProgressing) {
        onProgressing(record, Boolean(record?.async_progressing));
      }

      if (!record?.async_progressing) {
        if (progressing) {
          if (onCompleted) {
            onCompleted(record);
          }
          this.setState({
            progressing: false,
            progress: 0,
            progressCounter: 0,
          });
        }
        return;
      }

      const progress = record?.async_progress;

      this.setState({
        progressing: record?.async_progressing,
        // Set progress to a lower number in case tasks are finishing after 100%
        progress:
          progress >= MAX_PROGRESS_PERCENT
            ? MAX_PROGRESS_PERCENT
            : parseInt(progress),
      });

      this.renderProgressCounter();

      this.monitorProgress();
    }, CHECK_ASYNC_TIMEOUT);
  }

  renderProgressCounter() {
    setTimeout(() => {
      if (!this.mounted) return;

      const { progress, progressCounter } = this.state;

      if (progressCounter < progress) {
        this.setState({
          progressCounter: progressCounter + 1,
        });
        this.renderProgressCounter();
      }
    }, 25);
  }

  async checkStatus() {
    const { endpoint, record, onCheckStatus } = this.props;

    if (!record) {
      return null;
    }

    if (onCheckStatus) {
      return onCheckStatus(record);
    }

    return api.get(`/${endpoint}/${record?.id}`);
  }

  render() {
    const { size = 16, children = null } = this.props;

    const { task, progressing, progress, progressCounter } = this.state;

    if (!task || !progressing) {
      return children;
    }

    return (
      <div className="loading-async-task">
        <Loading size={size} progress={progress} />
        {task.label}{' '}
        {progress > 0 ? (
          <span className="loading-async-task-percent">{progressCounter}%</span>
        ) : (
          ''
        )}
      </div>
    );
  }
}
